import { EdgelessDatabaseBackground } from './components/edgeless-database-background';
import { EdgelessDatabaseMask } from './components/edgeless-database-mask';
import { CenterPeek } from './components/layout';
import { DatabaseTitle } from './components/title';
import { databaseAppUsageEffects } from './database-app-usage';
import { DatabaseBlockComponent } from './database-block';
import { EdgelessDatabaseBlockComponent } from './database-canvas-block';
import { DatabaseDndPreviewBlockComponent } from './database-dnd-preview-block';
import { DatabaseProjectionStatusOverlay } from './database-projection-status-overlay';
import { BlockRenderer } from './detail-panel/block-renderer';
import { NoteRenderer } from './detail-panel/note-renderer';
import { CreatedByCell } from './properties/created-by/cell-renderer';
import { CreatedTimeCell } from './properties/created-time/cell-renderer';
import { LinkCell } from './properties/link/cell-renderer';
import { RichTextCell } from './properties/rich-text/cell-renderer';
import { IconCell } from './properties/title/icon';
import { HeaderAreaTextCell } from './properties/title/text';
import { UpdatedByCell } from './properties/updated-by/cell-renderer';
import { UpdatedTimeCell } from './properties/updated-time/cell-renderer';

export function effects() {
  customElements.define('affine-database-title', DatabaseTitle);
  databaseAppUsageEffects();
  customElements.define('data-view-header-area-icon', IconCell);
  customElements.define('affine-database-link-cell', LinkCell);
  customElements.define('data-view-header-area-text', HeaderAreaTextCell);
  customElements.define('affine-database-rich-text-cell', RichTextCell);
  customElements.define('affine-database-created-by-cell', CreatedByCell);
  customElements.define('affine-database-created-time-cell', CreatedTimeCell);
  customElements.define('affine-database-updated-time-cell', UpdatedTimeCell);
  customElements.define('affine-database-updated-by-cell', UpdatedByCell);
  customElements.define('center-peek', CenterPeek);
  customElements.define('database-datasource-note-renderer', NoteRenderer);
  customElements.define('database-datasource-block-renderer', BlockRenderer);
  customElements.define('affine-database', DatabaseBlockComponent);
  customElements.define(
    'database-projection-status-overlay',
    DatabaseProjectionStatusOverlay
  );

  customElements.define(
    'affine-dnd-preview-database',
    DatabaseDndPreviewBlockComponent
  );

  // Canvas/Edgeless components
  customElements.define(
    'affine-edgeless-database',
    EdgelessDatabaseBlockComponent
  );
  customElements.define(
    'edgeless-database-background',
    EdgelessDatabaseBackground
  );
  customElements.define('edgeless-database-mask', EdgelessDatabaseMask);
}
